
<template>
<div class="mt-3 py-5">
	<b-container class="px-3 p-md-0" v-if="display === 1">
		<b-row>
			<b-col cols="12" md="8" class="m-auto px-3">

				<!--<div class="back_ground_image1 container pt-5 pb-5 mb-auto">-->
					<div class="row justify-content-center pt-2 pb-5">
						<div class="col-md-8">
							<div class="card">
								<div class="card-header">パスワード再発行</div>

								<div class="card-body">

									<div class="form-group row mx-0">
										<label for="email" class="col-md-4 col-form-label text-md-right">メールアドレス</label>
										<div class="col-md-8">
											<input type="email" class="form-control" v-model="loginForm.email" required v-bind:class="{ error_input: loginForm.errors.email.length > 0 }">
											<div v-if="loginForm.errors.email.length > 0">
												<div class="error-text" v-for="(item, index) in loginForm.errors.email" :key="index">{{ item }}</div>
											</div>
										</div>
									</div>

									<div class="form-group row mx-0 mb-0">
										<div class="col-md-12 text-center">
											<button type="submit" class="btn btn-success" @click="send_reminder_mail">
												パスワード再発行URLを送信
											</button>
										</div>
									</div>

								</div>
							</div>
						</div>
					</div>
				<!--</div>-->

			</b-col>
		</b-row>
	</b-container>

	<b-container class="px-3 p-md-0" v-if="display === 2">
		<b-row>
			<b-col cols="12" md="8" class="m-auto px-3">

				<!--<div class="back_ground_image1 container pt-5 pb-5 mb-auto">-->
					<div class="row justify-content-center pt-2 pb-5">
						<div class="col-md-8">
							<div class="card">
								<div class="card-header">パスワード再発行</div>

								<div class="card-body p-2">

									<div class="container my-3">
										<div class="form-group w-100 m-auto p-1">
											パスワード再設定用のメールを送信しました。<br>
											メール内のリンクより、パスワードの再設定をお願いします。
										</div>
									</div>

								</div>
							</div>
						</div>
					</div>
				<!--</div>-->

			</b-col>
		</b-row>
	</b-container>
</div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
	name: 'LoginReminder',
	data () {
		return {
			display: 1,
			isError: false,
			loginForm: {
				errors: {
					email: [],
				},
				email: "",
			}
		}
	},
	methods: {

		send_reminder_mail() {
			this.isError = false;
			this.loginForm.errors.email = [];
			if (!this.loginForm.email) {
				this.loginForm.errors.email.push('メールアドレスが入力されていません');
				this.isError = true;
			}
			if (!this.isError) {
				this.change_password_application();
			} else {
				window.scrollTo({
					top: 0,
				});
			}
		},

		// 変更処理
		async change_password_application() {
			this.$store.dispatch('auth/change_password_application', {
				email: this.loginForm.email,
			}).then(response => {
				this.display = 2;
				window.scrollTo({
					top: 0,
				});
			}, error => {
				// バックエンドからエラーが返却された場合、ひとまずアラートでメッセージを出力
				console.log(error.response.data);
				if ('error' in error.response.data) {
					this.loginForm.errors.email.push('入力されたメールアドレスは登録されていません');
					window.scrollTo({
						top: 0,
					});
				}
			});
			return false;
		},

	}
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/LoginReminder.vue